import { useEffect, useState } from 'react'

interface ResponsiveLogoProps {
    src: string
    srcBig: string
    alt: string
    className?: string
}

export const ResponsiveLogo = ({ src, srcBig, alt, className }: ResponsiveLogoProps) => {
    const [isDesktop, setIsDesktop] = useState(false)

    useEffect(() => {
        setIsDesktop(window.innerWidth >= 768)

        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 768)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return <img src={isDesktop ? srcBig : src} alt={alt} className={className} />
}
